/**
 * Module access control based on user types
 * User Types: gods_eye, operador, verificador, driver
 */

export const MODULE_PERMISSIONS = {
  corporativo: {dashboard: true, trips: true, containers: true, reports: true},
  gods_eye: {
    dashboard: true,
    trips: true,
    containers: true,
    ports: true,
    companies: true,
    users: true,
    depots: true,
    reports: true,
    auditLogs: true,
    locationTracking: true,
  },
  operador: {
    dashboard: true,
    trips: true,
    containers: true,
    ports: false,
    companies: false,
    users: false,
    depots: false,
    reports: true,
    auditLogs: false,
    locationTracking: true,
  },
  verificador: {
    dashboard: true,
    trips: false,
    containers: true,
    ports: false,
    companies: false,
    users: false,
    depots: false,
    reports: true,
    auditLogs: false,
    locationTracking: true,
  },
  driver: {
    dashboard: true,
    trips: false,
    containers: false,
    ports: false,
    companies: false,
    users: false,
    depots: false,
    reports: false,
    auditLogs: false,
    locationTracking: true,
  },
};

/**
 * Check if user type has access to a specific module
 * @param {string} userType - The user type (gods_eye, operador, verificador, driver)
 * @param {string} module - The module name (e.g., 'trips', 'ports', 'reports')
 * @returns {boolean} - True if user has access to the module
 */
export function hasModuleAccess(userType, module) {
  if (!userType || !MODULE_PERMISSIONS[userType]) {
    return false;
  }
  return MODULE_PERMISSIONS[userType][module] === true;
}

/**
 * Get all accessible modules for a user type
 * @param {string} userType - The user type
 * @returns {Array} - Array of accessible module names
 */
export function getAccessibleModules(userType) {
  if (!userType || !MODULE_PERMISSIONS[userType]) {
    return [];
  }
  return Object.keys(MODULE_PERMISSIONS[userType]).filter(
    (module) => MODULE_PERMISSIONS[userType][module] === true
  );
}

/**
 * Module metadata for navigation
 */
export const MODULES = {
  dashboard: {
    name: 'Dashboard',
    path: '/',
    label: 'Dashboard',
  },
  trips: {
    name: 'Trips',
    path: '/trips',
    label: 'Trip Management',
  },
  containers: {
    name: 'Containers',
    path: '/containers',
    label: 'Containers',
  },
  ports: {
    name: 'Ports',
    path: '/ports',
    label: 'Port Management',
  },
  companies: {
    name: 'Companies',
    path: '/companies',
    label: 'Companies',
  },
  users: {
    name: 'Users',
    path: '/users',
    label: 'Users',
  },
  depots: {
    name: 'Depots',
    path: '/depots',
    label: 'Depots',
  },
  reports: {
    name: 'Reports',
    path: '/reports',
    label: 'Reports',
  },
  auditLogs: {
    name: 'Audit Logs',
    path: '/audit-logs',
    label: 'Audit Logs',
  },
  locationTracking: {
    name: 'Live Tracking',
    path: '/tracking',
    label: 'Live Tracking',
  },
};
